import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgDocIconComponent, NgDocTextComponent, NgDocTextLeftDirective, NgDocTextRightDirective } from '@ng-doc/ui-kit';
function NgDocPageNavigationComponent_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3)(1, "div", 4);
    i0.ɵɵelement(2, "ng-doc-icon", 5);
    i0.ɵɵtext(3, " Previous ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.prevPage.route);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.prevPage.title);
  }
}
function NgDocPageNavigationComponent_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7)(1, "div", 4);
    i0.ɵɵtext(2, " Next ");
    i0.ɵɵelement(3, "ng-doc-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.nextPage.route);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.nextPage.title);
  }
}
let NgDocPageNavigationComponent = /*#__PURE__*/(() => {
  class NgDocPageNavigationComponent {
    static {
      this.ɵfac = function NgDocPageNavigationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPageNavigationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPageNavigationComponent,
        selectors: [["ng-doc-page-navigation"]],
        inputs: {
          prevPage: "prevPage",
          nextPage: "nextPage"
        },
        decls: 3,
        vars: 2,
        consts: [[1, "ng-doc-navigation-controls"], ["class", "ng-doc-prev-page", 3, "routerLink", 4, "ngIf"], ["class", "ng-doc-next-page", 3, "routerLink", 4, "ngIf"], [1, "ng-doc-prev-page", 3, "routerLink"], ["ng-doc-text", "", "size", "small", 1, "ng-doc-navigation-page-label"], ["icon", "arrow-left", "ngDocTextLeft", ""], ["ng-doc-text", "", 1, "ng-doc-navigation-page-title"], [1, "ng-doc-next-page", 3, "routerLink"], ["icon", "arrow-right", "ngDocTextRight", ""]],
        template: function NgDocPageNavigationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, NgDocPageNavigationComponent_a_1_Template, 6, 2, "a", 1)(2, NgDocPageNavigationComponent_a_2_Template, 6, 2, "a", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.prevPage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.nextPage);
          }
        },
        dependencies: [CommonModule, i1.NgIf, NgDocIconComponent, NgDocTextComponent, NgDocTextLeftDirective, NgDocTextRightDirective, RouterLink],
        styles: ["[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]{display:flex;margin-top:calc(var(--ng-doc-base-gutter) * 12);border-top:1px solid var(--ng-doc-base-2);padding-top:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;flex-direction:column;text-decoration:unset;transition:var(--ng-doc-transition);--ng-doc-button-hover-background: var(--ng-doc-base-1);--ng-doc-button-active-background: var(--ng-doc-base-2);--ng-doc-text: var(--ng-doc-base-9);--ng-doc-icon-color: var(--ng-doc-text)}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{opacity:.6}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a.ng-doc-next-page[_ngcontent-%COMP%]{margin-left:auto}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a.ng-doc-prev-page[_ngcontent-%COMP%]{align-items:flex-start}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a.ng-doc-next-page[_ngcontent-%COMP%]{align-items:flex-end}[_nghost-%COMP%]   .ng-doc-navigation-controls[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .ng-doc-navigation-page-title[_ngcontent-%COMP%]{--ng-doc-text: var(--ng-doc-link-color)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocPageNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocPageNavigationComponent };
